import React from 'react';
import { useTranslation } from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography } from '@mui/material';
import { IconButton } from 'components/IconButton';

import ServiceRouter, { useServiceRouter } from '@common/components/ServiceRouter';
import { type IStudentProgramLessonModel } from '@common/models/StudentPrograms/StudentProgramLesson';

import ProgramsLessonCommentButton from '../../CommentButton';
import ProgramsLessonGradeButton from '../../Grade';
import { StyledLessonStatus } from '../styled';

interface PropsType {
	lesson: IStudentProgramLessonModel;
}
function LessonStatusCompleted({ lesson }: PropsType) {
	const { t } = useTranslation();
	const isAasL = lesson.assessment_type_id === 3;
	const { checkService } = useServiceRouter();

	const CompletedStatusComponent = (
		<StyledLessonStatus
			color="success"
			label={
				<>
					<Typography variant="subtitle3">{t('program.completed')}</Typography>
					<CheckIcon />
				</>
			}
		/>
	);

	let statusContent;

	if (lesson?.gradebook_final_grade) {
		if (isAasL || checkService('talented')) {
			statusContent = CompletedStatusComponent;
		} else {
			statusContent = (
				<IconButton variant="contained" color="info">
					<Typography variant="subtitle3">{lesson.gradebook_final_grade}</Typography>
				</IconButton>
			);
		}
	} else {
		statusContent = CompletedStatusComponent;
	}

	return (
		<Box display="flex" alignItems="center" gap="8px">
			{lesson.comment && (
				<ProgramsLessonCommentButton
					teacherName={`${lesson.teacher_first_name} ${lesson.teacher_last_name}`}
					created_at={lesson.comment_created_at}
					comment={lesson.comment}
				/>
			)}

			<ServiceRouter
				lyceum={
					<ProgramsLessonGradeButton
						grade={lesson.grade}
						gradebookFinalGrade={lesson.gradebook_final_grade}
					/>
				}
			>
				{statusContent}
			</ServiceRouter>
		</Box>
	);
}

export default LessonStatusCompleted;
